import Jtab, { JTabItem } from '@atoms/JTab';
import { IconSize } from '@constants';
import {
  BuildingOffice2Icon,
  GlobeAltIcon,
  IdentificationIcon,
  PlusCircleIcon,
} from '@heroicons/react/24/outline';
import { PlayIcon } from '@heroicons/react/24/solid';
import CandidatesSettings from '@settings/components/CandidatesSettings';
import CvVideosStepsSettings from '@settings/components/CvVideosStepsSettings';
import EnterprisesSettings from '@settings/components/EnterprisesSettings';
import CreditsSettings from '@settings/components/CreditsSettings';
import GeneralSettings from '@settings/components/GeneralSettings';

const itemsList: JTabItem[] = [
  {
    title: 'GENERAL',
    icon: <GlobeAltIcon height={IconSize.buttonIcon} />,
    component: <GeneralSettings />,
  },
  {
    title: 'CANDIDATES',
    icon: <IdentificationIcon height={IconSize.buttonIcon} />,
    component: <CandidatesSettings />,
  },
  {
    title: 'CV_VIDEOS',
    icon: <PlayIcon height={IconSize.buttonIcon} />,
    component: <CvVideosStepsSettings />,
  },
  {
    title: 'ENTERPRISES',
    icon: <BuildingOffice2Icon height={IconSize.buttonIcon} />,
    component: <EnterprisesSettings />,
  },
  {
    title: 'CREDITS',
    icon: <PlusCircleIcon height={IconSize.buttonIcon} />,
    component: <CreditsSettings />,
  },
];

const SettingsPage = () => {
  return <Jtab items={itemsList} />;
};

export default SettingsPage;
